import { render } from "./SaleCustomersSummary.vue?vue&type=template&id=a8a40618&scoped=true"
import script from "./SaleCustomersSummary.vue?vue&type=script&lang=js"
export * from "./SaleCustomersSummary.vue?vue&type=script&lang=js"

import "./SaleCustomersSummary.vue?vue&type=style&index=0&id=a8a40618&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8a40618"]])

export default __exports__